'use client';

import { Main as MainStyled } from '@/styles/global.elements';

import { useBanner } from '@/providers/banner.provider';

const Main = ({ children }) => {
  const { headerHeight } = useBanner();

  return <MainStyled $headerHeight={headerHeight}>{children}</MainStyled>;
};

export { Main };
